export var DEFAULT_ERROR_IDS = /*#__PURE__*/function (DEFAULT_ERROR_IDS) {
  DEFAULT_ERROR_IDS["ERR_GENERIC"] = "ERR_GENERIC";
  DEFAULT_ERROR_IDS["ERR_403"] = "ERR_403";
  DEFAULT_ERROR_IDS["ERR_ROUTER"] = "ERR_ROUTER";
  return DEFAULT_ERROR_IDS;
}(DEFAULT_ERROR_IDS || {});
export const ERROR_PAGE_DATA_DEFAULTS = {
  ERR_GENERIC: {
    summary: 'Unbekannter Fehler',
    message: 'Es liegen keine weiteren Informationen vor. Teilen Sie uns gerne mit, was genau passiert ist.'
  },
  ERR_403: {
    summary: 'Fehler: Zugriff nicht erlaubt',
    status: 403,
    message: 'Sie haben nicht die erforderlichen Rechte, um diese Seite aufzurufen.'
  },
  ERR_ROUTER: {
    summary: 'Fehler',
    // status:404, -- no default status for ROUTER error! there may be non-404 issues that have no status code which would be irritating.
    message: 'Die Seite konnte nicht geladen werden werden.'
  }
};